<template>
   <div class="bg-light pt-3 pt-lg-5 pb-5">
      <b-container fluid>
         <b-row>
            <b-col cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>
            <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">
               <h5>Avaliações</h5>

               <el-tabs v-model="activeTab">

                  <!-- RECEBIDAS -->
                  <el-tab-pane label="Recebidas" name="recebidas">

                     <!-- Métricas -->
                     <b-row class="mt-3 mb-4 metrics">

                        <b-col v-loading="loading.data" cols="12" md="6" class="mb-3 mb-xl-0">
                           <div class="bg-white rounded p-3 text-center">
                              <h6 class="mb-3">Sua média é:</h6>
                              <el-progress
                                 type="dashboard"
                                 :percentage="calcRating(ratings.rateMetrics.averageRating)"
                                 color="#ff9900"
                                 :width="80"
                                 :stroke-width="5"
                                 :format=" () => ratings.rateMetrics.averageRating"
                              ></el-progress>
                           </div>
                        </b-col>

                        <b-col v-loading="loading.data" cols="12" md="6" class="mb-3 mb-xl-0">
                           <div class="bg-white rounded p-3 text-center">
                              <h6 class="mb-3">Total de Avaliações</h6>
                              <h1 class="mb-2">{{ ratings.total }}</h1>
                              <el-rate
                                 class="mb-1"
                                 v-model="ratings.rateMetrics.averageRating"
                                 disabled
                                 show-score
                                 disabled-void-color="#d0d4df"
                                 text-color="#ff9900"
                                 score-template="">
                              </el-rate>
                           </div>
                        </b-col>
                     </b-row>

                     <el-table
                        v-loading="loading.data"
                        class="mt-3"
                        :data="ratings.ratings"
                        style="width: 100%"
                        stripe
                        max-height="800"
                     >
                        <!-- Expanded Details Column / Coluna detalhes expandidos  -->
                        <el-table-column
                           type="expand">
                           <template slot-scope="props">
                              <b-row>


                                 <b-col cols="12" md="6"><p><strong>Postado em:</strong>
                                    {{ props.row.createdAt | moment("DD/MM/YYYY [às] H:mm:ss") }}</p></b-col>

                                 <b-col cols="12" md="6"><p><strong>Avaliado por:</strong>
                                    {{ props.row.by.firstName + ' ' + props.row.by.lastName }}</p></b-col>

                                 <b-col cols="12" md="4">

                                    <p><strong>Reserva:</strong> #{{ props.row.order.orderN }}</p>
                                 </b-col>

                                 <b-col cols="12" md="8">

                                    <p><strong>Bicicleta:</strong> <a :href="`/bicicleta/${props.row.order.bike.slug}`"
                                                                      target="_blank">{{
                                          props.row.order.bike.name
                                       }}</a></p>
                                 </b-col>

                                 <b-col cols="12" md="12">
                                    <p><strong>Comentário: </strong>{{ props.row.comment }}</p>
                                 </b-col>

                                 <b-col cols="12" md="12">  <!-- Open Modal Booking /  Abre o Booking Modal -->
                                    <el-button
                                       @click="openDenounceModal(props.row)"
                                       type="primary"
                                       plain
                                       size="mini"
                                       class="text-uppercase font-weight-bold pt-1 pb-1"
                                       round>Denunciar
                                    </el-button>
                                 </b-col>

                              </b-row>

                           </template>
                        </el-table-column>

                        <!-- Reserve Number Column / Coluna Reserva Número -->
                        <el-table-column
                           align="center"
                           prop="order"
                           label="Reserva"
                           width="100"
                           sortable
                           column-key="order"
                        >
                           <template slot-scope="scope">
                              <span>#{{ scope.row.order.orderN }}</span>
                           </template>
                        </el-table-column>

                        <!-- Comment Column / Coluna Comentário -->
                        <el-table-column
                           prop="comment"
                           label="Comentário"
                           width="330"
                        >
                           <template slot-scope="scope">
                              <span :title="scope.row.bike">{{ scope.row.comment }}</span>
                           </template>
                        </el-table-column>

                        <!-- Coluna Comentário -->
                        <el-table-column
                           v-if="false"
                           prop="ref"
                           label="Avaliação"
                           width="130"
                        >
                           <template slot-scope="scope">
                              <span>{{ renderNameSpace(scope.row.namespace) }}</span>
                           </template>
                        </el-table-column>

                        <!-- para -->
                        <el-table-column
                           prop="by"
                           label="Avaliado por"
                           width="160"
                        >
                           <template slot-scope="scope">
                              <span>{{ scope.row.by.firstName + ' ' + scope.row.by.lastName }}</span>
                           </template>
                        </el-table-column>

                        <!-- Rate Column / Coluna Nota -->
                        <el-table-column
                           prop="rate"
                           label="Nota"
                           width="175"
                           sortable
                        >
                           <template slot-scope="scope">
                              <el-rate
                                 v-model="scope.row.rate"
                                 disabled
                                 show-score
                                 text-color="#ff9900"
                                 score-template="{value}">
                              </el-rate>
                           </template>
                        </el-table-column>
                     </el-table>

                     <el-pagination
                        class="mt-3"
                        background
                        layout="total, sizes, prev, pager, next"
                        :current-page.sync="pagination.page"
                        @current-change="changePage('receive')"
                        @size-change="changeSize('receive')"
                        :page-size="10"
                        :page-sizes="[10, 20, 30, 50, 100, 500]"
                        :total="pagination.total">
                     </el-pagination>

                  </el-tab-pane>

                  <!-- ENVIADAS -->
                  <el-tab-pane label="Enviadas" name="enviadas">

                     <el-table
                        v-loading="loading.data"
                        class="mt-3"
                        :data="myRatings.ratings"
                        style="width: 100%"
                        stripe
                        max-height="800"
                     >
                        <!-- Expanded Details Column / Coluna detalhes expandidos  -->
                        <el-table-column
                           type="expand">

                           <template slot-scope="props">
                              <b-row>
                                 <b-col cols="12" md="6"><p><strong>Postado em:</strong>
                                    {{ props.row.createdAt | moment("DD/MM/YYYY [às] H:mm:ss") }}</p></b-col>

                                 <b-col cols="12" md="6">

                                    <p v-if="props.row.namespace === 'Bike'">
                                       <strong>Anfitrião:</strong>
                                       {{ props.row.order.owner.firstName + ' ' + props.row.order.owner.lastName }}
                                    </p>

                                    <p v-if="!props.row.bike">
                                       <strong>Ciclista:</strong> {{
                                          props.row.order.customer.firstName + ' ' + props.row.order.customer.lastName
                                       }}
                                    </p>

                                 </b-col>

                                 <b-col cols="12" md="4">

                                    <p><strong>Reserva:</strong> #{{ props.row.order.orderN }}</p>
                                 </b-col>

                                 <b-col cols="12" md="8">

                                    <p><strong>Bicicleta:</strong> <a :href="`/bicicleta/${props.row.order.bike.slug}`"
                                                                      target="_blank">{{
                                          props.row.order.bike.name
                                       }}</a></p>
                                 </b-col>


                                 <b-col cols="12">
                                    <p><strong>Comentário: </strong>{{ props.row.comment }}</p>
                                 </b-col>


                                 <b-col cols="12" md="12">  <!-- Open Modal Booking /  Abre o Booking Modal -->
                                    <el-button
                                       @click="openDenounceModal(props.row.bookNumber)"
                                       type="primary"
                                       plain
                                       size="mini"
                                       class="text-uppercase font-weight-bold pt-1 pb-1"
                                       round>Denunciar Comentário
                                    </el-button>
                                 </b-col>

                              </b-row>

                           </template>
                        </el-table-column>

                        <!-- Reserve Number Column / Coluna Reserva Número -->
                        <el-table-column
                           align="center"
                           prop="order"
                           label="Reserva"
                           width="100"
                           sortable
                           column-key="order"
                        >
                           <template slot-scope="scope">
                              <span>#{{ scope.row.order.orderN }}</span>
                           </template>
                        </el-table-column>

                        <!-- Comment Column / Coluna Comentário -->
                        <el-table-column
                           prop="comment"
                           label="Comentário"
                           width="330"
                        >
                           <template slot-scope="scope">
                              <span :title="scope.row.bike">{{ scope.row.comment }}</span>
                           </template>
                        </el-table-column>

                        <!-- Coluna Tipo -->
                        <el-table-column
                           v-if="false"
                           prop="ref"
                           label="Avaliação"
                           width="130"
                        >
                           <template slot-scope="scope">
                              <span>{{ renderNameSpace(scope.row.namespace) }}</span>
                           </template>
                        </el-table-column>

                        <!-- Coluna Para -->
                        <el-table-column
                           prop="by"
                           label="Para"
                           width="160"
                        >
                           <template slot-scope="scope">
                              <div>
                        <span>
                           {{ scope.row.forUserId.firstName + ' ' + scope.row.forUserId.lastName }}
                        </span>

                              </div>
                           </template>
                        </el-table-column>

                        <!-- Rate Column / Coluna Nota -->
                        <el-table-column
                           prop="rate"
                           label="Nota"
                           width="175"
                           sortable
                        >
                           <template slot-scope="scope">
                              <el-rate
                                 v-model="scope.row.rate"
                                 disabled
                                 show-score
                                 text-color="#ff9900"
                                 score-template="{value}">
                              </el-rate>
                           </template>
                        </el-table-column>
                     </el-table>

                     <el-pagination
                        class="mt-3"
                        background
                        layout="total, sizes, prev, pager, next"
                        :current-page.sync="pagination.page"
                        @current-change="changePage('send')"
                        @size-change="changeSize('send')"
                        :page-size="10"
                        :page-sizes="[10, 20, 30, 50, 100, 500]"
                        :total="pagination.total">
                     </el-pagination>

                  </el-tab-pane>

               </el-tabs>


            </b-col>
         </b-row>

         <!--=== Reject Reservation Info Modal / Abre o Modal de Informações para Aprovar a Reserva /  Modal de Informações para Rejeitar a Reserva ===-->
         <el-dialog
            center
            class="modal-book inner-modal"
            :visible.sync="denounceModal"
            append-to-body>
            <!-- Modal Contents / Conteúdo do Modal -->
            <div class="text-center">
               <v-icon class="text-danger mb-3" scale="2" name="exclamation-circle"></v-icon>
               <h4 class="text-danger">Denunciar Comentário</h4>
               <p class="text-muted">Se você considera esse comentário como ofensivo, de carater malicioso, doloso, etc,
                  notifique para que possamos modera-lo</p>

               <!-- form to submit reason for rejection / Formulário para enviar o motivo da rejeição -->
               <el-form ref="formReason" :model="formReason" :rules="formReasonRules">
                  <el-form-item prop="reason">
                     <el-select v-model="formReason.reason" placeholder="Selecione o motivo">
                        <el-option v-for="(item, index) in rejectReason" :key="index" :label="item.label"
                                   :value="item.value"></el-option>
                     </el-select>
                  </el-form-item>
                  <el-form-item label="" prop="desc">
                     <el-input
                        placeholder="Descreva o motivo..."
                        :rows="2"
                        maxlength="150"
                        show-word-limit
                        type="textarea" v-model="formReason.desc"></el-input>
                  </el-form-item>


                  <!-- Submit | Enviar -->
                  <el-form-item>
                     <el-button
                        @click="submitDenounce('formReason')"
                        :loading="denounceLoading"
                        :round="true"
                        type="primary"
                        class="w-100 text-uppercase font-weight-bold">
                        Denunciar
                     </el-button>
                  </el-form-item>

               </el-form>
            </div>

            <!-- Action to Reject Reservation / Ação para Rejeitar a Reserva -->
            <div class="text-center mt-4">

            </div>
         </el-dialog>


      </b-container>

   </div>
</template>

<script>
import DashUserNav from "../../../../components/DashUserNav";
import UserService from "@/services/user.service";


export default {
   name: 'Comments',
   components: {
      DashUserNav
   },
   data() {
      return {
         activeTab: 'recebidas',
         tableReservationData: [
            {
               bookNumber: '004',
               bike: 'Cross Bike 24 marchas',
               commentDate: '18/01/2020 às 12:41',
               rate: 4,
               user: 'João Carlos',
               comment: 'Deinde disputat, quod cuiusque generis animantium statui deceat extremum. Quid de Pythagora? Nam quid possumus facere melius? Sed quot homines, tot sententiae; Pauca mutat vel plura sane; Pauca mutat vel plura sane.'
            },
            {
               bookNumber: '003',
               bike: 'Cross Bike 24 marchas',
               commentDate: '15/01/2020 às 10:10',
               rate: 3,
               user: 'Ana Maria',
               comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quorum sine causa fieri nihil putandum est. Nam de isto magna dissensio est. Duo Reges: constructio interrete. '
            },
            {
               bookNumber: '002',
               bike: 'Cross Bike 24 marchas',
               commentDate: '01/01/2020 às 02:12',
               rate: 5,
               user: 'Pedro Henrique',
               comment: 'Tamen a proposito, inquam, aberramus. Sed in rebus apertissimis nimium longi sumus. Quodsi ipsam honestatem undique pertectam atque absolutam. Hoc enim constituto in philosophia constituta sunt omnia. Quae similitudo in genere etiam humano apparet. Certe, nisi voluptatem tanti aestimaretis. Bonum patria: miserum exilium. '
            },
            {
               bookNumber: '001',
               bike: 'Cross Bike 24 marchas',
               commentDate: '23/12/2019 às 05:13',
               rate: 1,
               user: 'Julio',
               comment: 'Aperiendum est igitur, quid sit voluptas; Hoc mihi cum tuo fratre convenit. Confecta res esset. Falli igitur possumus. Quid censes in Latino fore? Quae contraria sunt his, malane? Sed ad rem redeamus; '
            },
         ],
         ratings: {
            rateMetrics: {
               totalRatings: 0,
               averageRating: 0
            },
            rateBikeMetrics: {
               totalRatings: 0,
               averageRating: 0
            },
            rateUserMetrics: {
               totalRatings: 0,
               averageRating: 0
            }
         },
         myRatings: {},
         denounceModal: false,
         formReason: {
            reason: '',
            desc: ''
         },
         formReasonRules: {
            reason: [
               {required: true, message: 'Selecione o motivo', trigger: 'blur'},
            ],
            desc: [
               {required: true, message: 'Detalhe o motivo', trigger: 'blur'},
            ],
         },
         rejectReason: [
            {label: "Ofensivo", value: "1"},
            {label: "Comentário com conteúdo falso", value: "2"},
            {label: "Grosseiro", value: "3"},
            {label: "Faltou com Respeito", value: "4"},
         ],
         denounceLoading: false,
         reportSent: false,
         loading: {
            data: false
         },
         deleteCommentState: false,
         pagination: {
            total: 0,
            page: 1,
            perPage: 10
         },
      }
   },
   async mounted() {
      await this.getRatingsReceived()
   },
   methods: {

      openDenounceModal(comment) {

         let user = { comment: comment.comment, id: comment._id, by: comment.by.firstName + ' ' +  comment.by.lastName };

         const body = `&body=Olá, recebi um comentário ofensivo e gostaria de reportá-lo para o time de suporte da Pedale.%0A ID do comentário: ${user.id}.%0A Feito por: ${user.by}.%0A Comentário: ${user.comment}.`


         location.href = 'mailto:contato@pedale.net.br?Subject=Ajuda%20Pedale%20-%20Comentário%20ofensivo%20-%20Feito por:%20' + user.by + body;

         //this.denounceModal = true
      },

      submitDenounce(formName) {

         this.$refs[formName].validate((valid) => {

            if (valid) {
               this.denounceLoading = true;
               setTimeout(() => {
                  this.denounceLoading = false;
                  this.denounceModal = false;
                  this.$message.success('Denúncia enviada com sucesso!', valid);
                  this.$refs[formName].resetFields();
               }, 1000);

            } else {
               //console.log('error submit!!');
               this.$message.warning('Por favor, preencha todos os campos corretamente!');
               return false;
            }
         });
      },

      deleteComment() {
         this.$confirm('Tem certeza de que deseja excluir este comentário?', 'Atenção', {
            confirmButtonText: 'Sim, tenho',
            cancelButtonText: 'Cancelar',
            type: 'danger'
         }).then(() => {
            this.$message({
               type: 'success',
               message: 'O comentário foi deletado com sucesso!'
            });
         })
      },

      async getSendRatings() {
         this.loading.data = true

         const ratings = ( await UserService.getRatings('send', this.pagination.perPage, this.pagination.page)).data

         if (ratings) {
            this.myRatings = ratings
            this.pagination.total = this.myRatings.total
            this.loading.data = false
         } else {
            this.loading.data = false
         }

      },

      async getRatingsReceived() {

         this.loading.data = true
         const ratings = (await UserService.getRatings('receive', this.pagination.perPage, this.pagination.page)).data

         if (ratings) {
            this.ratings = ratings
            this.pagination.total = ratings.total
            this.loading.data = false
         } else {
            this.loading.data = false
         }

      },

      calcRating(rate) {

         return rate * 2 * 10
      },

      renderNameSpace(nameSpace) {

         let str;

         switch (nameSpace) {
            case 'User':
               str = 'Pessoal'
               break
            case 'Bike':
               str = 'da Bicicleta'
         }

         return str

      },

      async changePage(type) {
         if (type === 'receive') {
            await this.getRatingsReceived()
         }

         if (type === 'send') {
            await this.getSendRatings()
         }

      },

      async changeSize(type) {
         if (type === 'receive') {
            await this.getRatingsReceived()
         }

         if (type === 'send') {
            await this.getSendRatings()
         }

      },

      resetPagination() {
         this.pagination.total = 0
         this.pagination.page = 1
         this.pagination.perPage = 10
      }

   },

   computed: {},

   watch: {
      activeTab: async function (n) {
         if (n === 'enviadas') {
            await this.getSendRatings()
            this.resetPagination()
         }
         if (n === 'recebidas') {
            await this.getRatingsReceived()
            this.resetPagination()
         }
      }
   }
};
</script>

<style lang="scss">

.metrics {
   .el-progress--circle .el-progress__text, .el-progress--dashboard .el-progress__text {
      font-size: 25px !important;
      color: #56b54c;
      font-weight: bold;
   }

   .el-rate__icon {
      font-size: 17px;
   }
}
</style>
